export default {
  title: 'AITA.center',
  backToDashboard: 'Назад на дашборд',
  launchSoon: 'Скоро запуск',
  heroTag: 'AI-центр Gonka Game',
  heroTitle: 'Нейросети —',
  heroHighlight: 'в одном окне.',
  heroLead:
    'Пишите тексты, создавайте изображения и видео, разбирайте документы. Популярные AI-модели и готовые инструменты — рядом.',
  accessNote: 'На русском · Оплата в рублях · Без VPN',
  ssoNote: 'Вход через Gonka Game',
  mascotAlt: 'Персонаж Gonka Game с логотипами AI-моделей',
  demoLabel: 'Пример работы инструмента',
  demoPrompt: 'Напиши пост о новом продукте',
  demoAnswer:
    'Представляем наш новый продукт! Он помогает быстрее создавать контент и экономить время. Попробуйте и расскажите, как вам результат.',
  previewLabel: 'Пример',
  openCenter: 'Открыть AITA.center',
  whatItDoes: 'Возможности',
  networksValue: '25+',
  networksLabel: 'нейросетей',
  toolsValue: '100+',
  toolsLabel: 'готовых инструментов',
  textFrom: 'текст от',
  textPrice: '$0.01',
  painTag: 'знакомо?',
  painTitle: 'Одна задача — несколько открытых вкладок?',
  painLead:
    'Для публикации нужен текст, к нему — картинка, а ещё короткий ролик. Не хочется собирать всё это в разных сервисах.',
  painPayment: 'Зарубежную подписку нечем оплатить',
  painVpn: 'Некоторые сервисы недоступны без VPN',
  painSwitching:
    'Для текста, картинки и видео приходится переключаться между сервисами',
  painInterface: 'В незнакомом интерфейсе непонятно, с чего начать',
  painTrial: 'Не хочется платить, пока не попробовали',
  featuresTag: 'возможности',
  featuresTitle: 'От идеи до результата.',
  featuresLead:
    'Напишите пост, создайте к нему картинку и короткое видео. Здесь же можно подготовить ответ клиенту или разобрать документ — без перехода в другой сервис.',
  textsTitle: 'Тексты и документы',
  textsDescription: 'Посты, ответы клиентам, сценарии и разбор файлов.',
  imagesTitle: 'Изображения',
  imagesDescription: 'Обложки, баннеры и карточки товаров.',
  videoTitle: 'Видео',
  videoDescription: 'Короткие ролики из описания или фотографии.',
  assistantsTitle: 'AI-помощники',
  assistantsDescription: 'Идеи для контента, маркетинга и продаж.',
  assistantsCount: '6 ассистентов',
  voiceInput: 'голосовой ввод',
  tasksTag: 'готовые инструменты',
  tasksTitle: 'Начните со знакомой задачи.',
  tasksLead: 'Выберите инструмент и опишите, что хотите получить.',
  telegramTitle: 'Пост в Телеграм',
  telegramDescription:
    'Укажите тему и для кого пишете — получите текст для своего канала.',
  instagramTitle: 'Карусель для Instagram',
  instagramDescription:
    'Расскажите о товаре или разберите тему в серии слайдов с текстом и картинками.',
  marketplaceTitle: 'Карточка товара',
  marketplaceDescription:
    'Покажите товар и его особенности на картинке для Wildberries или Ozon.',
  transcriptionTitle: 'Расшифровка эфира',
  transcriptionDescription:
    'Загрузите видео или голосовое — получите текст записи, краткое содержание или материал для поста.',
  photoTitle: 'Улучшить фото',
  photoDescription:
    'Уберите лишний фон, улучшите качество снимка или покажите предмет с другого ракурса.',
  reportTitle: 'Разобрать отчёт',
  reportDescription:
    'Загрузите Excel или PDF и задайте вопросы по данным — не нужно разбирать весь файл в одиночку.',
  previousCard: 'Предыдущая карточка',
  nextCard: 'Следующая карточка',
  audienceTag: 'для кого',
  audienceTitle: 'Для работы. Для своих идей.',
  bloggersTitle: 'Ведёте блог',
  bloggersDescription: 'Готовьте посты, картинки и короткие видео.',
  sellersTitle: 'Продаёте онлайн',
  sellersDescription: 'Оформляйте товары и отвечайте покупателям.',
  beginnersTitle: 'Пробуете AI впервые',
  beginnersDescription: 'Начните с готового инструмента.',
  startTag: 'как начать',
  startTitle: 'Три шага до первого результата.',
  accountTitle: 'Откройте AITA.center',
  accountDescription:
    'Войдите через свой аккаунт Gonka Game и перейдите в AITA.center.',
  chooseTitle: 'Выберите задачу',
  chooseDescription: 'Напишите запрос или откройте готовый инструмент.',
  reviewTitle: 'Проверьте результат',
  reviewDescription:
    'Скачайте результат. Перед публикацией проверьте текст, факты и детали на картинке.',
  pricingTag: 'тарифы',
  pricingTitle: 'Начните бесплатно.',
  pricingLead:
    'Выберите тариф и расходуйте кредиты на свои задачи. Стоимость зависит от модели и формата.',
  planAudienceHeading: 'Для чего',
  freePurpose: 'Познакомиться с сервисом',
  starterPurpose: 'Для своих задач',
  proPurpose: 'Для регулярной работы',
  viewPlans: 'Посмотреть тарифы в AITA.center',
  priceTextTag: 'Текст',
  priceTextValue: 'от $0.01',
  priceTextDescription: 'пост или описание',
  priceImageTag: 'Изображения',
  priceImageValue: 'от $0.05',
  priceImageDescription: 'одна генерация',
  priceVideoTag: 'видео 5 сек',
  priceVideoValue: 'от $0.40',
  priceVideoDescription: 'один ролик',
  planHeading: 'Тариф',
  priceHeading: 'Цена',
  capacityHeading: 'Хватит примерно на',
  freePlan: 'Бесплатный',
  freePrice: '$0',
  freeCapacity: 'попробовать',
  starterPlan: 'Старт',
  starterPrice: '$9/мес',
  starterCapacity: '~180 картинок, или ~22 видео, или ~900 текстов',
  proPlan: 'Про',
  proPrice: '$19/мес',
  proCapacity: '~380 картинок, или ~47 видео + безлимит Gemini и DeepSeek',
  faqTag: 'вопросы',
  faqTitle: 'Частые вопросы',
  vpnQuestion: 'Нужен ли VPN?',
  vpnAnswer:
    'Нет. Сервис работает из России. При оплате VPN лучше выключить — банки могут отклонить платёж.',
  beginnerQuestion: 'Я никогда не пользовался нейросетями. С чего начать?',
  beginnerAnswer:
    'Выберите знакомую задачу, например пост для своего канала. Готовый инструмент поможет составить запрос. Интерфейс на русском; вместо набора текста можно использовать голосовой ввод.',
  creditsQuestion: 'Что такое кредиты?',
  creditsAnswer:
    'Это внутренние единицы для оплаты задач на платформе. Кредиты списываются при генерации; расход зависит от модели и задачи. Обычно текст требует меньше кредитов, чем видео. Актуальные условия тарифов можно посмотреть в AITA.center.',
  commercialQuestion: 'Можно использовать результаты в работе и рекламе?',
  commercialAnswer:
    'Да, коммерческое использование разрешено на платных тарифах.',
  modelsQuestion: 'Зачем платформа, если уже есть ChatGPT?',
  modelsAnswer:
    'Здесь можно выбирать разные модели для текста, картинок и видео в одном аккаунте. Не нужно переходить в другой сервис, чтобы добавить к посту изображение или короткий ролик. Для доступа не нужен VPN, для оплаты — зарубежная карта.',
  finalTitle: 'Начните со своей задачи.',
  finalDescription: 'Пост, картинка или видео — выберите, что нужно сегодня.',
}
